import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Package } from "lucide-react";
import LoginForm from "@/components/LoginForm";

const STATUS_LABELS = {
  paid: { label: "Payée", color: "#00F0FF" },
  processing: { label: "En préparation", color: "#FFD700" },
  shipped: { label: "Expédiée", color: "#B026FF" },
  delivered: { label: "Livrée", color: "#39FF14" },
  cancelled: { label: "Annulée", color: "#FF0033" },
};

export default function MesCommandes() {
  const { user, loading: authLoading } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) return;
    api.get("/shop/orders/mine").then(({ data }) => setOrders(data)).catch(() => {}).finally(() => setLoading(false));
  }, [user]);

  if (authLoading) return <div className="text-center py-20 text-white/40">Chargement...</div>;
  if (!user) return <LoginForm subtitle="Connecte-toi pour retrouver l'historique de tes commandes." />;
  if (loading) return <div className="text-center py-20 text-white/40">Chargement...</div>;

  return (
    <div className="max-w-3xl mx-auto px-5 pt-10 pb-16">
      <h1 className="font-display font-black text-3xl tracking-tight mb-8">Mes commandes</h1>

      {orders.length === 0 ? (
        <div className="text-center py-16 text-white/40 flex flex-col items-center gap-3">
          <Package size={32} className="opacity-40" />
          <p>Aucune commande pour le moment.</p>
          <Link to="/" className="btn-solid inline-flex !py-3 !px-6 mt-2">Voir la boutique</Link>
        </div>
      ) : (
        <div className="space-y-3">
          {orders.map((o) => {
            const status = STATUS_LABELS[o.status] || STATUS_LABELS.paid;
            return (
              <div key={o.order_id} className="card-glass p-5">
                <div className="flex justify-between items-start gap-3 flex-wrap mb-3">
                  <span className="text-xs text-white/40">{new Date(o.created_at).toLocaleDateString("fr-FR", { day: "numeric", month: "long", year: "numeric" })}</span>
                  <span className="px-3 py-1 rounded-full text-[10px] font-bold uppercase tracking-wider" style={{ color: status.color, border: `1px solid ${status.color}` }}>
                    {status.label}
                  </span>
                </div>
                <div className="space-y-1 mb-3">
                  {(o.items || []).map((it, i) => (
                    <p key={i} className="text-sm">{it.product_name}{it.size && ` (${it.size})`} × {it.quantity}</p>
                  ))}
                </div>
                <div className="flex justify-between items-center pt-3 border-t border-white/5">
                  <span className="text-xs text-white/40">Total</span>
                  <span className="font-display font-bold text-[#00F0FF]">{(o.amount_total_cents / 100).toFixed(2)}€</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
